import { render, staticRenderFns } from "./Forward.vue?vue&type=template&id=83ede8e6&scoped=true&"
import script from "./Forward.vue?vue&type=script&lang=js&"
export * from "./Forward.vue?vue&type=script&lang=js&"
import style0 from "./Forward.vue?vue&type=style&index=0&id=83ede8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ede8e6",
  null
  
)

export default component.exports